import { render, staticRenderFns } from "./CatalogTravelInformationFrom.vue?vue&type=template&id=13858e0b&"
import script from "./CatalogTravelInformationFrom.vue?vue&type=script&lang=js&"
export * from "./CatalogTravelInformationFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports